import { Table } from "@mantine/core";

import type { VolumeOut } from "../../api/generated/model";
import { fmt0, fmtPct, fmtRange } from "./tables";

/** Sectors 1–18 and the total, as the run measured them. */
export function SectorTable({ sectors }: { sectors: VolumeOut[] }) {
  return (
    <Table withTableBorder striped fz="xs" data-testid="sector-table">
      <Table.Thead>
        <Table.Tr>
          <Table.Th>Sector</Table.Th>
          <Table.Th ta="right">Volume m³</Table.Th>
          <Table.Th ta="right">Range m³</Table.Th>
          <Table.Th ta="right">Tonnes</Table.Th>
          <Table.Th ta="right">Unseen</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {sectors.map((v) => (
          <Table.Tr key={`${v.scope}-${v.scope_id ?? ""}`} fw={v.scope === "total" ? 700 : undefined}>
            <Table.Td>{v.scope === "total" ? "Total" : v.scope_id}</Table.Td>
            <Table.Td ta="right">{fmt0(v.v_best_m3)}</Table.Td>
            <Table.Td ta="right">
              {fmtRange(v.v_min_m3, v.v_max_m3)}
            </Table.Td>
            <Table.Td ta="right">{fmt0(v.tonnes_t)}</Table.Td>
            <Table.Td ta="right">{fmtPct(v.unobserved_frac)}</Table.Td>
          </Table.Tr>
        ))}
      </Table.Tbody>
    </Table>
  );
}
